import PropTypes from 'prop-types'

import styles from '../style.module.scss'

export const MailIcon = () => (
	<svg
		className={styles.fieldIcon}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={2}
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<rect x="2" y="4" width="20" height="16" rx="2" />
		<path d="m22 6-10 7L2 6" />
	</svg>
)

export const PhoneIcon = () => (
	<svg
		className={styles.fieldIcon}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={2}
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
	</svg>
)

export const ShieldCheckIcon = ({ className }) => (
	<svg
		className={className}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={2}
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
		<path d="m9 12 2 2 4-4" />
	</svg>
)

ShieldCheckIcon.propTypes = {
	className: PropTypes.string
}

/**
 * E-Mail und Telefon einer Person.
 *
 * Eine fehlende Nummer laesst die Zeile ganz weg — ein Telefonsymbol ohne
 * Nummer dahinter sieht aus, als waere etwas nicht geladen.
 */
export const ContactLines = ({ email, phone }) => (
	<div className={styles.personContact}>
		{!!email && (
			<p className={styles.employeeEmail}>
				<MailIcon />
				{email}
			</p>
		)}
		{!!phone && (
			<p className={styles.employeePhone}>
				<PhoneIcon />
				{phone}
			</p>
		)}
	</div>
)

ContactLines.propTypes = {
	email: PropTypes.string,
	phone: PropTypes.string
}
